// Convertit une erreur axios/fetch en message clair et "parlant" pour l'utilisateur.
// Couvre : pas de réseau, timeout, codes HTTP, message serveur nominatif, et un repli contextuel.
export function errorMessage(err, fallback = "Une erreur est survenue. Réessaie dans un instant.") {
  // Erreur réseau (serveur injoignable, hors-ligne, CORS, timeout)
  if (err?.code === 'ECONNABORTED') return "La requête a pris trop de temps. Vérifie ta connexion et réessaie.";
  if (err && err.message === 'Network Error') return "Connexion au serveur impossible. Vérifie ta connexion internet et réessaie.";
  if (err && !err.response) return "Impossible de joindre le serveur. Réessaie dans un instant.";

  const status = err.response?.status;
  const serverMsg = err.response?.data?.error || err.response?.data?.message;

  switch (status) {
    case 400: // requête invalide → le backend renvoie un message précis (champ manquant, format, etc.)
      return serverMsg || "Certaines informations sont invalides ou incomplètes.";
    case 401:
      return "Ta session a expiré. Reconnecte-toi pour continuer.";
    case 403:
      return serverMsg || "Tu n'as pas l'autorisation d'effectuer cette action.";
    case 404:
      return serverMsg || "Élément introuvable. Il a peut-être été supprimé.";
    case 409:
      return serverMsg || "Conflit : cette action entre en conflit avec un état existant.";
    case 429:
      return "Trop de tentatives en peu de temps. Patiente quelques minutes puis réessaie.";
    case 500:
    case 502:
    case 503:
      return "Le serveur rencontre un problème. Réessaie dans quelques instants.";
    default:
      return serverMsg || fallback;
  }
}

// Mappe une erreur backend vers un champ de formulaire quand c'est possible,
// pour afficher le message directement sous le bon champ.
export function fieldFromError(err) {
  const msg = (err?.response?.data?.error || '').toLowerCase();
  if (!msg) return null;
  if (msg.includes('email')) return 'email';
  if (msg.includes('mot de passe') || msg.includes('password')) return 'password';
  if (msg.includes('nom')) return 'name';
  if (msg.includes('date')) return 'date';
  if (msg.includes('lieu') || msg.includes('location')) return 'location';
  if (msg.includes('format')) return 'playerFormats';
  if (msg.includes('genre') || msg.includes('catégorie') || msg.includes('categorie')) return 'genders';
  if (msg.includes('niveau')) return 'level';
  return null;
}
